var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
!function (t, i) {
  exports = i();
}(exports, function () {
  "use strict";

  function t(t, i) {
    if (!(t instanceof i)) throw new TypeError("Cannot call a class as a function");
  }
  function i(t, i, n) {
    return i && function (t, i) {
      for (var n = 0; n < i.length; n++) {
        var o = i[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, e(o.key), o);
      }
    }(t.prototype, i), Object.defineProperty(t, "prototype", {
      writable: !1
    }), t;
  }
  function e(t) {
    var i = function (t, i) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var n = e.call(t, i);
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(t);
    }(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function n(t) {
    return +t.replace(/px/, "");
  }
  function o(t, i) {
    var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
      n = Math.random() * (i - t) + t;
    return Math.floor(n * Math.pow(10, e)) / Math.pow(10, e);
  }
  function s(t) {
    return t[o(0, t.length)];
  }
  var a = ["#fcf403", "#62fc03", "#f4fc03", "#03e7fc", "#03fca5", "#a503fc", "#fc03ad", "#fc03c2"];
  function r(t) {
    return Math.log(t) / Math.log(1920);
  }
  var h = function () {
    return i(function i(e) {
      t(this || _global, i);
      var n = e.initialPosition,
        a = e.confettiRadius,
        h = e.confettiColors,
        c = e.emojis,
        u = e.emojiSize,
        l = e.canvasWidth,
        f = e.initialFlightAngle,
        d = e.rotationAngle,
        m = e.shouldHideConfettiInShiftedPosition,
        v = void 0 !== m && m,
        p = o(0.9, 1.7, 3) * r(l);
      (this || _global).confettiSpeed = {
        x: p,
        y: p
      }, (this || _global).finalConfettiSpeedX = o(0.2, 0.6, 3), (this || _global).rotationSpeed = c.length ? 0.01 : o(0.03, 0.07, 3) * r(l), (this || _global).dragForceCoefficient = o(0.0005, 0.0009, 6), (this || _global).radius = {
        x: a,
        y: a
      }, (this || _global).initialRadius = a, (this || _global).rotationAngle = d, (this || _global).emojiSize = u, (this || _global).emojiRotationAngle = o(0, 2 * Math.PI), (this || _global).radiusYUpdateDirection = "down", (this || _global).cos = Math.cos(f), (this || _global).sin = Math.sin(f);
      var y = o(-150, 0);
      (this || _global).positionOffset = {
        x: y * (this || _global).sin,
        y: y * (this || _global).cos
      }, (this || _global).distanceTravelled = {
        x: 0,
        y: 0
      };
      var g = {
        x: n.x + (this || _global).positionOffset.x,
        y: n.y - (this || _global).positionOffset.y
      };
      (this || _global).currentPosition = Object.assign({}, g), (this || _global).initialPosition = Object.assign({}, g), (this || _global).color = c.length ? null : s(h), (this || _global).emoji = c.length ? s(c) : null, (this || _global).createdAt = new Date().getTime(), (this || _global).isVisible = !v;
    }, [{
      key: "draw",
      value: function (t) {
        var i = (this || _global).currentPosition,
          e = (this || _global).radius,
          n = (this || _global).color,
          o = (this || _global).emoji,
          s = (this || _global).rotationAngle,
          a = (this || _global).emojiRotationAngle,
          r = (this || _global).emojiSize;
        if ((this || _global).isVisible) {
          var h = window.devicePixelRatio;
          n ? (t.fillStyle = n, t.beginPath(), t.ellipse(i.x * h, i.y * h, e.x * h, e.y * h, s, 0, 2 * Math.PI), t.fill()) : o && (t.font = "".concat(r, "px serif"), t.save(), t.translate(h * i.x, h * i.y), t.rotate(a), t.textAlign = "center", t.fillText(o, 0, 0), t.restore());
        }
      }
    }, {
      key: "updatePosition",
      value: function (t, i) {
        var e = (this || _global).confettiSpeed,
          n = (this || _global).dragForceCoefficient,
          o = (this || _global).finalConfettiSpeedX,
          s = (this || _global).radiusYUpdateDirection,
          a = (this || _global).rotationSpeed,
          r = (this || _global).createdAt;
        e.x > o && ((this || _global).confettiSpeed.x -= n * t);
        var h = (this || _global).currentPosition.y,
          c = i - r;
        (this || _global).currentPosition.y = (this || _global).initialPosition.y - e.y * (this || _global).cos * c + 0.00125 * Math.pow(c, 2) / 2;
        var u = {
          x: e.x * (this || _global).sin * t,
          y: (this || _global).currentPosition.y - h
        };
        (this || _global).currentPosition.x += u.x, (this || _global).distanceTravelled.x += Math.abs(u.x), (this || _global).distanceTravelled.y += Math.abs(u.y), (this || _global).distanceTravelled.x >= Math.abs((this || _global).positionOffset.x) && (this || _global).distanceTravelled.y >= Math.abs((this || _global).positionOffset.y) && ((this || _global).isVisible = !0), (this || _global).rotationSpeed -= (this || _global).emoji ? 0.0001 : 0.00001 * t, (this || _global).rotationSpeed < 0 && ((this || _global).rotationSpeed = 0), (this || _global).emoji ? (this || _global).emojiRotationAngle += (this || _global).rotationSpeed * t % (2 * Math.PI) : "down" === s ? ((this || _global).radius.y -= t * a, (this || _global).radius.y <= 0 && ((this || _global).radius.y = 0, (this || _global).radiusYUpdateDirection = "up")) : ((this || _global).radius.y += t * a, (this || _global).radius.y >= (this || _global).initialRadius && ((this || _global).radius.y = (this || _global).initialRadius, (this || _global).radiusYUpdateDirection = "down"));
      }
    }, {
      key: "getIsVisibleOnCanvas",
      value: function (t) {
        return (this || _global).currentPosition.y < t + 100;
      }
    }]);
  }();
  function c(t) {
    var i = t.confettiRadius,
      e = void 0 === i ? 6 : i,
      n = t.confettiNumber,
      o = void 0 === n ? t.confettiesNumber || (t.emojis ? 40 : 250) : n,
      s = t.confettiColors,
      r = void 0 === s ? a : s,
      h = t.emojis,
      c = void 0 === h ? t.emojies || [] : h,
      u = t.emojiSize,
      l = void 0 === u ? 80 : u,
      f = t.confettiDispatchPosition,
      d = void 0 === f ? null : f;
    return t.emojies && console.error("emojies argument is deprecated, please use emojis instead"), t.confettiesNumber && console.error("confettiesNumber argument is deprecated, please use confettiNumber instead"), {
      confettiRadius: e,
      confettiNumber: o,
      confettiColors: r,
      emojis: c,
      emojiSize: l,
      confettiDispatchPosition: d
    };
  }
  function u(t) {
    return t * Math.PI / 180;
  }
  function l() {
    return u(o(82, 15));
  }
  function f() {
    return u(o(-15, -82));
  }
  function d() {
    return u(o(-150, 150));
  }
  function m() {
    return o(0, 0.2, 3);
  }
  function v() {
    return o(-0.2, 0, 3);
  }
  var p = function () {
      return i(function i(e) {
        var n = this || _global;
        t(this || _global, i), (this || _global).canvasContext = e, (this || _global).shapes = [], (this || _global).promise = new Promise(function (t) {
          return n.resolvePromise = t;
        });
      }, [{
        key: "getBatchCompletePromise",
        value: function () {
          return (this || _global).promise;
        }
      }, {
        key: "addShapes",
        value: function () {
          var t;
          (t = (this || _global).shapes).push.apply(t, arguments);
        }
      }, {
        key: "complete",
        value: function () {
          var t;
          return !(this || _global).shapes.length && (null === (t = (this || _global).resolvePromise) || void 0 === t || t.call(this || _global), !0);
        }
      }, {
        key: "processShapes",
        value: function (t, i, e) {
          var n = this || _global,
            o = t.timeDelta,
            s = t.currentTime;
          (this || _global).shapes = (this || _global).shapes.filter(function (t) {
            return t.updatePosition(o, s), t.draw(n.canvasContext), !e || t.getIsVisibleOnCanvas(i);
          });
        }
      }]);
    }(),
    y = function () {
      return i(function i() {
        var e,
          n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        t(this || _global, i), (this || _global).activeConfettiBatches = [], (this || _global).canvas = n.canvas || ((e = document.createElement("canvas")).style.position = "fixed", e.style.width = "100%", e.style.height = "100%", e.style.top = "0", e.style.left = "0", e.style.zIndex = "1000", e.style.pointerEvents = "none", document.body.appendChild(e), e), (this || _global).canvasContext = (this || _global).canvas.getContext("2d"), (this || _global).requestAnimationFrameRequested = !1, (this || _global).lastUpdated = new Date().getTime(), (this || _global).iterationIndex = 0, (this || _global).loop = (this || _global).loop.bind(this || _global), requestAnimationFrame((this || _global).loop);
      }, [{
        key: "loop",
        value: function () {
          var t, i, e, o, s;
          (this || _global).requestAnimationFrameRequested = !1, t = (this || _global).canvas, i = window.devicePixelRatio, e = getComputedStyle(t), o = n(e.getPropertyValue("width")), s = n(e.getPropertyValue("height")), t.setAttribute("width", (o * i).toString()), t.setAttribute("height", (s * i).toString());
          var a = new Date().getTime(),
            r = a - (this || _global).lastUpdated,
            h = (this || _global).canvas.offsetHeight,
            c = (this || _global).iterationIndex % 10 == 0;
          (this || _global).activeConfettiBatches = (this || _global).activeConfettiBatches.filter(function (t) {
            return t.processShapes({
              timeDelta: r,
              currentTime: a
            }, h, c), !c || !t.complete();
          }), (this || _global).iterationIndex++, this.queueAnimationFrameIfNeeded(a);
        }
      }, {
        key: "queueAnimationFrameIfNeeded",
        value: function (t) {
          (this || _global).requestAnimationFrameRequested || (this || _global).activeConfettiBatches.length < 1 || ((this || _global).requestAnimationFrameRequested = !0, (this || _global).lastUpdated = t || new Date().getTime(), requestAnimationFrame((this || _global).loop));
        }
      }, {
        key: "addConfettiAtPosition",
        value: function () {
          for (var t = c(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), i = t.confettiRadius, e = t.confettiNumber, n = t.confettiColors, o = t.emojis, s = t.emojiSize, a = t.confettiDispatchPosition, r = (this || _global).canvas.getBoundingClientRect().width, u = new p((this || _global).canvasContext), l = 0; l < e; l++) {
            var f = new h({
              initialPosition: a,
              confettiRadius: i,
              confettiColors: n,
              confettiNumber: e,
              emojis: o,
              emojiSize: s,
              canvasWidth: r,
              rotationAngle: m(),
              initialFlightAngle: d(),
              shouldHideConfettiInShiftedPosition: !0
            });
            u.addShapes(f);
          }
          return (this || _global).activeConfettiBatches.push(u), this.queueAnimationFrameIfNeeded(), u.getBatchCompletePromise();
        }
      }, {
        key: "addConfetti",
        value: function () {
          for (var t = c(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), i = t.confettiRadius, e = t.confettiNumber, n = t.confettiColors, o = t.emojis, s = t.emojiSize, a = (this || _global).canvas.getBoundingClientRect(), r = a.width, u = 5 * a.height / 7, d = {
              x: 0,
              y: u
            }, y = {
              x: r,
              y: u
            }, g = new p((this || _global).canvasContext), C = 0; C < e / 2; C++) {
            var b = new h({
                initialPosition: d,
                confettiRadius: i,
                confettiColors: n,
                confettiNumber: e,
                emojis: o,
                emojiSize: s,
                canvasWidth: r,
                rotationAngle: m(),
                initialFlightAngle: l()
              }),
              x = new h({
                initialPosition: y,
                confettiRadius: i,
                confettiColors: n,
                confettiNumber: e,
                emojis: o,
                emojiSize: s,
                canvasWidth: r,
                rotationAngle: v(),
                initialFlightAngle: f()
              });
            g.addShapes(x, b);
          }
          return (this || _global).activeConfettiBatches.push(g), this.queueAnimationFrameIfNeeded(), g.getBatchCompletePromise();
        }
      }, {
        key: "clearCanvas",
        value: function () {
          (this || _global).activeConfettiBatches = [];
        }
      }, {
        key: "destroyCanvas",
        value: function () {
          (this || _global).canvas.remove();
        }
      }]);
    }();
  return y;
});
export default exports;